var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWireProcessingDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 214,
    viewBox: "0 0 181 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.815 31.7793V209.517H3.68555V31.7793H152.815Z",
    stroke: "#062433",
    strokeWidth: 7.37184
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7937 187.529V3.70312L152.497 4.27407L176.704 40.9652V187.529H25.7937Z",
    fill: "#F5F5F5",
    stroke: "#062433",
    strokeWidth: 7.37184
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7646 98.377H151.733",
    stroke: "#062433",
    strokeWidth: 7.37184
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7646 73.209H151.733",
    stroke: "#062433",
    strokeWidth: 7.37184
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7646 123.547H151.733",
    stroke: "#062433",
    strokeWidth: 7.37184
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7646 148.715H151.733",
    stroke: "#062433",
    strokeWidth: 7.37184
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.484 4.64062V40.0385H175.462",
    stroke: "#062433",
    strokeWidth: 7.37184
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireProcessingDocument);
export default __webpack_public_path__ + "static/media/wire-processing-document.b8b6fbdeaba1fc293fdd0cfd1aa8d99a.svg";
export { ForwardRef as ReactComponent };